import JDate from "jalali-date";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import {
  faCircle,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

const itemValue = {
  commandTimer: [
    { key: "0", value: "قطع" },
    { key: "1", value: "وصل" },
    { key: "2", value: "ندارد" },
  ],
  outputRelay: [
    { key: "0", value: "قطع" },
    { key: "1", value: "وصل" },
  ],
  sensorZone1: [
    { key: "0", value: "تحریک نشده" },
    { key: "1", value: "تحریک شده" },
  ],
  sensorZone2: [
    { key: "0", value: "تحریک نشده" },
    { key: "1", value: "تحریک شده" },
  ],
  sensorZone3: [
    { key: "0", value: "تحریک نشده" },
    { key: "1", value: "تحریک شده" },
  ],
  power: [
    {
      key: "0",
      value: (
        <div
          style={{
            color: "red",
            display: "flex",
            flexDirection: "row",
            columnGap: 5,
          }}
        >
          <span>قطع</span>
          <FontAwesomeIcon icon={faCircle} />
        </div>
      ),
    },
    {
      key: "1",
      value: (
        <div
          style={{
            color: "blue",
            display: "flex",
            flexDirection: "row",
            columnGap: 5,
          }}
        >
          <span>وصل</span>
          <FontAwesomeIcon icon={faCircle} />
        </div>
      ),
    },
    { key: "2", value: "باتری" },
  ],
  security: [
    {
      key: "0",
      value: (
        <div
          style={{
            color: "orange",
            display: "flex",
            flexDirection: "row",
            columnGap: 5,
          }}
        >
          <span>غیرفعال</span>
          <FontAwesomeIcon icon={faCircle} />
        </div>
      ),
    },
    {
      key: "1",
      value: (
        <div
          style={{
            color: "blue",
            display: "flex",
            flexDirection: "row",
            columnGap: 5,
          }}
        >
          <span>فعال</span>
          <FontAwesomeIcon icon={faCircle} />
        </div>
      ),
    },
    {
      key: "2",
      value: (
        <div
          style={{
            color: "red",
            display: "flex",
            flexDirection: "row",
            columnGap: 5,
          }}
        >
          <span>هشدار</span>
          <FontAwesomeIcon icon={faCircle} />
        </div>
      ),
    },
  ],
  tankerWaterState: [
    { key: "0", value: "پایین" },
    { key: "1", value: "متوسط" },
    { key: "2", value: "بالا" },
  ],
};

export function analyze(array, updateInterval = null) {
  const result = [];
  for (let i = 0; i < array.length; i++) {
    const item = array[i];
    const date = new Date(Date.parse(item.datetime));
    const jdate = new JDate(date);
    item.datetime = `${jdate.format("YYYY/MM/DD")} ${date.toLocaleTimeString(
      "en-GB"
    )}`;

    if (updateInterval !== null) {
      const diffInMiliSeconds = Date.now() - date.getTime();
      const diffInSeconds = diffInMiliSeconds / 1000;
      if (diffInSeconds > updateInterval) {
        item.icon = (
          <span style={{ color: "orange" }}>
            <FontAwesomeIcon icon={faTriangleExclamation} />
          </span>
        );
      }
    }
    if (item.waterPercentage >= 80) {
      item.waterPercentage = (
        <span style={{ color: "blue", fontWeight: "bold" }}>
          {item.waterPercentage}
        </span>
      );
    } else if (item.waterPercentage >= 50 && item.waterPercentage < 80) {
      item.waterPercentage = (
        <span style={{ color: "orange", fontWeight: "bold" }}>
          {item.waterPercentage}
        </span>
      );
    } else {
      item.waterPercentage = (
        <span style={{ color: "red", fontWeight: "bold" }}>
          {item.waterPercentage}
        </span>
      );
    }
    item.englishDatetime = date;
    if (updateInterval !== null) {
      const diffInMiliSeconds = Date.now() - date.getTime();
      const diffInSeconds = diffInMiliSeconds / 1000;
      if (diffInSeconds > updateInterval) {
        item.icon = (
          <span style={{ color: "orange" }}>
            <FontAwesomeIcon icon={faTriangleExclamation} />
          </span>
        );
        item.hasAlert = true;
      }
    }
    for (const [key, value] of Object.entries(item)) {
      const reportStatusLabelArray = itemValue[key];
      if (reportStatusLabelArray) {
        reportStatusLabelArray.forEach((status) => {
          if (status.key == value) {
            item[key] = status.value;
          }
        });
      }
    }
    result.push(item);
  }
  return result;
}
